module.exports = __webpack_public_path__ + "img/soster.1224c1e3.png";